<template lang="pug">
div(class="py-20 -mt-5 bg-blue-500 bg-bottom bg-no-repeat bg-cover" style="background-image: url(https://website-assets.atlan.com/img/jd-pattern.webp);")
  .container.pt-4
    .flex.flex-col.col-md-8.px-0
      .my-6.text-center(class="md:my-8 md:px-0 md:text-left")
        img(width="75%" src="https://website-assets.atlan.com/img/illustrations/careers-mobile.webp" alt="altText" class="md:hidden")
        .mb-20
          h1.text-white.mb-3.text-5xl.font-semibold {{job.text}}
          h4.text-white.mb-0.text-2xl.font-semibold {{job.categories ? job.categories.location : ""}}
          h4.text-white.opacity-75.mb-0.font-semibold.text-xl {{job.categories ? job.categories.commitment : ""}}
          //- pre {{job}}
        .flex.flex-col.items-center.gap-x-4.gap-y-8(class="md:flex-row")
          a.btn.btn-pink-500(href="#application-form" class="!rounded-sm !px-10") Apply Now
          a.btn.btn-white(href="/careers/?p=open-positions/#job-list" class="!rounded-sm !px-10 !text-blue-500") View All Positions
</template>

<script setup lang="ts">
import DefaultButton from "@components/common-blocks/buttons/DefaultButton.vue";
const props = defineProps({
  job: {
    type: Object,
    default: () => ({}),
  },
});
</script>
